import { render, staticRenderFns } from "./moreFaces.vue?vue&type=template&id=c21021f0"
import script from "./moreFaces.vue?vue&type=script&lang=js"
export * from "./moreFaces.vue?vue&type=script&lang=js"
import style0 from "./moreFaces.vue?vue&type=style&index=0&id=c21021f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports